import clsx from 'clsx';
import React, { FC, useEffect, useRef, useState } from 'react';

import { useGlitchTransitionStore } from 'state/glitchTransitionStore';
import { useAudioStore } from 'state/sfx/audioStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

import { LAYER_IMAGES } from './GlitchTransition.utils';

import S from './GlitchTransition.module.scss';

import { useIntervalCustom } from 'hooks/useIntervalCustom';

export interface GlitchTransitionProps {
  className?: string;
}

const GlitchTransition: FC<GlitchTransitionProps> = ({ className }) => {
  const [visibleIndex, setVisibleIndex] = useState(-1);
  const isPlaying = useGlitchTransitionStore(s => s.isPlaying);
  const setIsPlaying = useGlitchTransitionStore(s => s.setIsPlaying);

  const isAllowedAudio = useAudioStore(s => s.isAllowed);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const audioSrc = useSoundsPreloadStore(
    s => s.library?.['general_digital_static']?.src
  );

  useEffect(() => {
    if (isPlaying && audioRef.current) {
      audioRef.current.play();
    }
  }, [isPlaying]);

  useIntervalCustom(
    () => setVisibleIndex(current => current + 1),
    isPlaying && visibleIndex < LAYER_IMAGES.length
      ? visibleIndex === -1
        ? 0
        : 50
      : null,
    visibleIndex === -1
      ? () => {}
      : () => {
          setVisibleIndex(-1);
          setIsPlaying(false);
        }
  );

  return (
    <div className={clsx(S.GlitchTransition, className)}>
      {LAYER_IMAGES.map((imagePath, index) => (
        <div
          key={index}
          className={S.Layer}
          style={{ opacity: isPlaying ? (index === visibleIndex ? 1 : 0) : 0 }}
        >
          <img className={S.Image} src={imagePath} />
        </div>
      ))}

      <audio
        ref={audioRef}
        src={audioSrc}
        muted={!isAllowedAudio}
        preload="auto"
      />
    </div>
  );
};
export default GlitchTransition;
